import * as React from 'react';

function SvgDocumentPdf(props) {
  return (
    <svg width={125} height={169} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M76.136 107.667l-4.789-1.018-4.334 20.388 4.79 1.019c5.866 1.246 9.927-1.656 11.352-8.357 1.363-6.415-1.262-10.808-7.019-12.032zM45.904 101.034l-4.834-1.027-2.344 11.029 4.812 1.023c3.8.808 6.43-.654 7.187-4.213.766-3.603-.998-5.999-4.821-6.812z"
        fill="#E8E8E8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M147.085 69.504a5.744 5.744 0 00-.808-4.324L116.496 19.3a5.78 5.78 0 00-3.638-2.5L38.212.932a5.744 5.744 0 00-6.82 4.429L.31 151.595a5.744 5.744 0 004.428 6.82l112.487 23.909a5.743 5.743 0 006.82-4.428l23.04-108.392zm-87.911 61.791l6.743-31.724 12.479 2.652c9.425 2.003 13.66 8.874 11.549 18.804-2.19 10.304-8.801 14.938-18.292 12.921l-12.48-2.653zm-30.32-6.444l6.74-31.703 13.225 2.811c6.526 1.387 10.056 6.707 8.655 13.298-1.387 6.526-6.952 9.912-13.63 8.493l-6.262-1.331-2.092 9.842-6.635-1.41zm73.193 2.652l-2.624 12.348-6.635-1.411 6.739-31.702 20.761 4.413-1.205 5.668-14.126-3.003-1.756 8.261 12.896 2.741-1.153 5.427-12.897-2.742zm31.517-58.172l-26.047-40.109-7.031 33.078 33.078 7.031z"
        fill="#E8E8E8"
      />
    </svg>
  );
}

export default SvgDocumentPdf;
